export const EventTypes = {
  pageVisited: 'page_visited',
  sessionCompleted: 'session_completed'
};
